import { lllLookupService } from "modules/lll/lll-lookup"
import { LllNode } from "modules/lll/lll-nodes"


export class LllNodeBranch {

  private nodes: LllNode[] = [];

  private constructor(nodes: LllNode[]) {
    this.nodes = nodes;
  }

  get description(): string {
    const result = this.nodes.map( e => e.displayName || e.name)
      .join(' -> ')
    return result;
  }

  get topicDisplay(): string {
    const types: LllNode['type'][] = ['subject', 'topic'];

    return this.nodes.filter( e => types.includes(e.type))
      .map(e => e.displayName || e.name)
      .join(' -> ');
  }

  get activityDisplay(): string {
    const types: LllNode['type'][] = ['activity-group', 'activity'];

    return this.nodes.filter( e => types.includes(e.type))
      .map(e => e.displayName || e.name)
      .join(' -> ');
  }

  hasSubject(subject: string): boolean {

    for(let i=this.nodes.length-1;i>=0;i--){
      const node = this.nodes[i];
      if(node.isTopic() && node.subjectName) {
        return node.subjectName.includes(subject);
      }
    }

    return false;
  }

  /**
   * iterate the nodes from "bottom up"
   * @param f a function to call for each node. if the function returns true, the iteration is stopped
   * @return the node where the iteration was stopped
   */
  bottomUpLoop( f: (node: LllNode) => boolean | void) {

    for(let i=this.nodes.length-1;i>=0;i--){
      const node = this.nodes[i];
      const stop = f(node);
      if(stop){
        return node;
      }
    }

  }

  static createTo(toNode: LllNode) {
    const flatNodes = lllLookupService.flatNodes;
    const branchNodes = [];
    let node = toNode;

    if(toNode) {
      branchNodes.push(toNode);
    }

    while(node) {
      const fqn = node.fqn;
      const lastIdx = fqn.lastIndexOf('~');

      if(lastIdx === -1) {
        break;
      }

      const parentFqn = fqn.substring(0, lastIdx);
      const parentNode = flatNodes[parentFqn];
      if(parentNode) {
        branchNodes.unshift(parentNode);
      }
      node = parentNode;

    }

    return new LllNodeBranch(branchNodes);
  }

}